import Hero from '../components/section/hero'
import Footer from '../components/menu/footer'
import Navbar from '../components/menu/navbar'
import Visas from '../components/section/visas'
import Founder from '../components/section/founder'
import CallToAction from '../components/section/cta'
import FrequentlyAskedQuestions from '../components/section/faq'
import Newsletter from '../components/section/newsletter'
import ScrollButton from '../components/button/scroll'
import Services from '../components/section/services'

export default function Landing() {
  return (
    <>
      <Navbar />
      <Hero />
      <Visas />
      <Services />
      <CallToAction />
      <FrequentlyAskedQuestions />
      <Founder />
      <Newsletter />
      <Footer />
      <ScrollButton />
    </>
  )
}
